import React, { useState, useEffect, useRef } from 'react';
import './Footer.css';
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';

const Footer = ({ 
    onTermsClick, 
    onPrivacyClick, 
    isLoggedIn, 
    onLoginClick,
    onLogoutClick 
}) => {
    const [isAdmin, setIsAdmin] = useState(false);

    const handleAdminClick = () => {
        window.location.href = '/admin';  // Navigate to admin page
    };

    // When checking login status, also check admin group
    useEffect(() => {
        const checkAuth = async () => {
            // If not logged in, definitely not admin
            if (!isLoggedIn) {
                setIsAdmin(false);
                return;
            }
            
            try {
                const session = await fetchAuthSession();
                const groups = session.tokens?.accessToken?.payload['cognito:groups'] || [];
                setIsAdmin(groups.includes('admin'));
            } catch (error) {
                console.error('Error checking admin status:', error);
                setIsAdmin(false);
            }
        };
        
        checkAuth();
    }, [isLoggedIn]);
    
    return (
        <footer className="site-footer">
            <div className="footer-content">
                <div className="footer-memorial">
                    <img 
                        src="/logo192.png" 
                        alt="Jeffrey Discs Logo" 
                        className="footer-logo"
                    />
                    <p className="memorial-text memorial-text-small">
                        In Memory of
                    </p>
                    <p className="memorial-text memorial-text-large">
                        Jeffrey Lucas Gurmendi Marshall
                    </p>
                </div>
                
                <div className="footer-links">
                    <button className="footer-link" onClick={onTermsClick}>
                        Terms of Service
                    </button>
                    <span className="footer-separator">•</span>
                    <button className="footer-link" onClick={onPrivacyClick}>
                        Privacy Policy
                    </button>
                    <span className="footer-separator">•</span>
                    {isLoggedIn ? (
                        <button className="footer-link" onClick={onLogoutClick}>
                            Logout (Family Members)
                        </button>
                    ) : (
                        <button className="footer-link" onClick={onLoginClick}>
                            Login As a Family Member
                        </button>
                    )}
                    {isAdmin && (
                        <>
                            <span className="footer-separator">•</span>
                            <button className="footer-link" onClick={handleAdminClick}>
                                Admin Dashboard
                            </button>
                        </>
                    )}
                </div>
                
                <div className="footer-copyright">
                    <p>© {new Date().getFullYear()} DoZESQ Imaginarium. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;